import React, { useEffect, useState, useRef } from "react";
import Select from 'react-select'
import {
  SlOption,
  SlSelect,
  SlButton,
  SlInput,
  SlIcon,
  SlTooltip,
  SlDrawer
} from "@shoelace-style/shoelace/dist/react";
// import { languageOptions } from "../../utils/constants";
import { debounce } from "../../utils/Debounce";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import API from "../../services/api";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import AddBrand from "./AddBrand";
import { formatDate } from "../../utils/dateFormat";
import Merge from "./Merge";
import POCC from "./POC";
import AssignBrand from "./AssignBrand";
import AssignHistory from "./AssignHistory";
import Accordion from "./Accordion";
import { BrandsTypes, getGenerateUrl, roles, brandLabels } from "../../utils/constants";
import { BRAND_HIDDEN_FIELDS, brandFieldLabel, formatBrandValue } from "../MakerChecker/payload/brandFormat";
import { Toast } from "../../shared/Toast";
import { CSVLink } from "react-csv";
import AssignTarget from "./AssignTarget";
import filterSvg from "../../assets/images/filter.svg";
function Brands() {
  const [language, setLanguage] = useState("all");
  const [search, setSearch] = useState("");
  const [brandData, setBrandData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [add, setAdd] = useState(false);
  const [merge, setMerge] = useState(false);
  const [mergeIds, setMergeIds] = useState([]);
  const [POC, setPOC] = useState();
  const [assign, setAssign] = useState(false);
  const [actionId, setActionId] = useState();
  const [unassignTarget, setUnassignTarget] = useState(null);
  const [historyBrand, setHistoryBrand] = useState(null);
  const [unassignClicked, setUnassignClicked] = useState(false);
  const [viewPoc, setviewPoc] = useState(false);
  const [flag, setFlag] = useState("add");
  const [editData, setEditdata] = useState();
  const [categories, setCategories] = useState([]);
  const [adType, setAdType] = useState(["1"]);
  const [location, setLocation] = useState("all");
  const [brandLocations, setBrandLocations] = useState([]);
  const [brandAssignedStatus, setBrandAssignedStatus] = useState("all");
  const [category, setCategory] = useState("all");
  const [salesList, setSaleslist] = useState([]);
  const [sales_id, setSales_id] = useState(null);
  const [target, setTarget] = useState(false);
  const [statObj, setStatObj] = useState({
    total: 0,
    assigned: 0,
    unassigned:0
  });
  const [downloadData, setDownloadData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [sales_person_id, set_Sales_Person_Id] = useState(null);
  const csvLinkRef = useRef();
  let csvHeaders = [
    { label: "Brand Name", key: "brand_name" },
    { label: "Alias Names", key: "alias_names" },
    { label: "Assigned to", key: "assigned_to" },
    { label: "Type", key: "brand_ad_type" },
    { label: "Location", key: "brand_location" },
    { label: "BrandType", key: "brand_type"}
]; // Create a ref for CSVLink
  // const langugageFilterChange = (e) => {
  //   setLanguage(e.target.value);
  // };
  const adTypeOptions = [
    { label: "Finite", value: "Finite" },
    { label: "Infinite", value: "Infinite" }

  ]
  const [selectedItem, setSelectedItem] = useState();
  const [showDrawer, setShowDrawer] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [pendingRequestData,setpendingRequestData] = useState([]);
  const [editflag,setEditFlag] = useState(false);
  const searchBrand = (e) => {
    setSearch(e.target.value);
  };
  const loadCategories = async () => {
    if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
      // setLoader(true);
      const response = await API({
        url: `/birdview/newspapers_categories`,
        method: "POST",
        responseType: "json",
      });
      if (response?.code === 200) {
        setCategories(response?.data?.result);
        // setLoader(false);
      } else {
        Toast("error", response?.data?.message);
      }
    }
  };
  const getBrands = async (page = 0) => {
    setLoader(true);
    try {
      let res = await API({
        url: "/birdview/getBrands",
        method: "POST",
        responseType: "json",
        data: {
          language,
          search,
          page,
          adType,
          location,
          brandAssignedStatus,
          category,
          sales_id,
          // limit: config.PER_PAGE,
          limit: 100,
        },
      });
      if (res.code === 200) {
        setBrandData(res.data?.result?.data);
        setTotalPages(Math.ceil(res.data?.result?.totalCount / 100));
        setStatObj({
          total: res.data?.result?.totalCount,
          assigned: res.data?.result?.assignedCount,
          unassigned: Math.max(res.data?.result?.totalCount -res.data?.result?.assignedCount , 0),
        });
        getBrandsLocations();
      }
      else{
        setBrandData([])
        setTotalPages(0)
        Toast('error', res.message)
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };

  const getBrandsLocations = async (page = 0) => {
    setLoader(true);
    try {
      let res = await API({
        url: "/birdview/brandsLocations",
        method: "POST",
        responseType: "json",
      });
      if (res.code === 200) {
        setBrandLocations([{label: "All", value: 'all'},{label: "Blanks", value: null},...res.data?.result]);
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    getBrands(event.selected);
  };
  const confirmUnassign = async () => {
    const item = unassignTarget;
    if (!item) return;
    const salesId =
      item.sales_person_id ??
      item.sales_details?.[0]?.sales_id ??
      item.sales_details?.[0]?.sales_person_id;
    try {
      setUnassignClicked(true);
      const res = await API({
        url: "/birdview/unAssignBrandSales",
        method: "POST",
        responseType: "json",
        data: { brand_id: item.brand_id, sales_id: salesId },
      });
      if (res.code === 200) {
        Toast("success", "Brand unassigned successfully");
        setUnassignTarget(null);
        getBrands(currentPage);
      } else {
        Toast("error", res?.message || "Failed to unassign brand");
      }
    } catch (error) {
      console.error("Error @ confirmUnassign", error);
      Toast("error", "Failed to unassign brand");
    } finally {
      setUnassignClicked(false);
    }
  };
  const handleCheckboxChange = (brand) => {
    setMergeIds((prevSelectedRows) => {
      const index = prevSelectedRows.findIndex((item) => item.id === brand.id);
      if (index !== -1) {
        return prevSelectedRows.filter((item, idx) => idx !== index);
      } else {
        return [...prevSelectedRows, brand];
      }
    });
  };

  const downloadBrands = async () => {
    setDownloadLoader(true);
    try {
      let res = await API({
        url: "/birdview/downloadBrands",
        method: "POST",
        responseType: "json",
        data: {
          language,
          search,
          adType,
          location,
          brandAssignedStatus,
          sales_id,
        },
      });
      if (res.code === 200) {
        setDownloadData(res.data);
      }
    } catch (error) {
      console.error(error);
    }
    finally{
      setDownloadLoader(false);
    }
  };
  const fetchPOC = async (brand) => {
    try {
      let res = await API({
        url: "/b2b_contacts/getBrandContacts",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: brand,
        },
      });
      if (res.code === 200) {
        setPOC(res.data.result);
        setviewPoc(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getBrands(0);
    loadCategories();
  }, [language, search, adType, location, brandAssignedStatus, category, sales_id]);

  const defaultValue = (options, value) => {
    return options ? options.filter((option) => option.value === value) : "";
  };

  const getSales = async (department_id) => {
    try {
      let res = await API({
        url: "/user/sales_persons/getSalesByDepartment",
        method: "POST",
        responseType: "json",
        data: {
          department_id,
        },
      });
      setSaleslist([{label: "All", value: 0},...res.data]);
      return res.data;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(()=>{
    getSales();
  },[])
  useEffect(() => {
    if (downloadData.length) {
        csvLinkRef?.current?.link?.click();
        setDownloadData([]);
    }
  }, [downloadData]);

  const handleContinueEditing = async () => {
    setShowDrawer(false);
    setFlag("edit");
    console.log("added",add);
    setAdd(true);
    // setActionId({
    //   id: editData?.brand_id,
    //   name: editData?.brand_name,
    // });
    setEditFlag(false);
  };


  const handleSkipEditing = () => {
    console.log("here")
    console.log(add);
    setShowDrawer(false);
  };

  const checkRequestPending = async(item)=>{
     try{

      let res = await API({
        url: '/birdview/editRequestPending',
        method: "POST",
        responseType: "json",
        data: {
          brand_id:item.brand_id
        }
      })
      if(res.code === 200)
      {  
         if(res.data?.payload)
         { 
          setpendingRequestData(res.data);
          setShowDrawer(true);
         }
         else
         {
          setEditFlag(true);
          handleContinueEditing();
         }
      }
     }catch(err)
     {
       console.log(err);
     }
  }

  // Portal react-select menus to <body> so they aren't clipped inside the
  // filter drawer (and stay above everything on desktop too).
  const rsStyles = {
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuList: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  // Shared filter fields — rendered inline on desktop and inside the drawer on
  // mobile. inDrawer stacks them full-width instead of fixed column widths.
  const renderFilters = (inDrawer = false) => (
    <>
      <div className={inDrawer ? "w-full" : "min-w-[220px] flex-1"}>
        <label className="mb-1 block text-xs font-medium text-slate-500">Search brand</label>
        <SlInput
          className="w-full"
          size="medium"
          placeholder="Search brand or alias…"
          type="text"
          onSlInput={debounce(searchBrand, 500)}
        >
          <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
        </SlInput>
      </div>
      <div className={inDrawer ? "w-full" : "w-44"}>
        <label className="mb-1 block text-xs font-medium text-slate-500">Brand type</label>
        <SlSelect
          className="w-full"
          placeholder="All types"
          name="adType"
          size="medium"
          value={adType}
          multiple={true}
          onSlChange={(e) => { (setAdType(e.target.value)) }}
        >
          {BrandsTypes?.map((item) => {
            return <SlOption value={item.value}>{item.label}</SlOption>;
          })}
        </SlSelect>
      </div>
      <div className={inDrawer ? "w-full" : "w-40"}>
        <label className="mb-1 block text-xs font-medium text-slate-500">Assigned status</label>
        <SlSelect
          className="w-full"
          placeholder="All"
          name="brandAssignedStatus"
          size="medium"
          value={brandAssignedStatus}
          onSlChange={(e) => { (setBrandAssignedStatus(e.target.value)) }}
        >
          <SlOption value="all">All</SlOption>
          <SlOption value="assigned">Assigned</SlOption>
          <SlOption value="unassigned">Unassigned</SlOption>
        </SlSelect>
      </div>
      {categories?.length > 0 && (
        <div className={inDrawer ? "w-full" : "w-44"}>
          <label className="mb-1 block text-xs font-medium text-slate-500">Category</label>
          <Select
            placeholder="All categories"
            name="category"
            value={defaultValue([{ label: "All", value: "all" }, ...categories], category)}
            onChange={(selected) => { setCategory(selected.value) }}
            options={[{ label: "All", value: "all" }, ...categories]}
            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            styles={rsStyles}
          />
        </div>
      )}
      <div className={inDrawer ? "w-full" : "w-44"}>
        <label className="mb-1 block text-xs font-medium text-slate-500">Location</label>
        <Select
          placeholder="All locations"
          name="location"
          value={defaultValue(brandLocations, location)}
          onChange={(e) => { setLocation(e.value) }}
          options={brandLocations}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          styles={rsStyles}
        />
      </div>
      <div className={inDrawer ? "w-full" : "w-44"}>
        <label className="mb-1 block text-xs font-medium text-slate-500">Sales person</label>
        <Select
          placeholder="Sales person"
          value={defaultValue(salesList, sales_id)}
          onChange={(selected) => { setSales_id(selected.value) }}
          options={salesList}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          styles={rsStyles}
        ></Select>
      </div>
    </>
  );

  return (
    <>
      <div className="flex h-[calc(100vh-72px)] flex-col">
      {/* ===== Header ===== */}
      <div className="flex flex-wrap items-center justify-between gap-3 shrink-0">
        <div className="flex items-center gap-3 flex-wrap">
          <h4 className="mb-0 text-2xl font-semibold text-slate-800">Brands</h4>
          <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">{statObj.total} Brands</span>
          <span className="inline-flex items-center rounded-full bg-green-50 px-3 py-1 text-xs font-semibold text-green-700">{statObj.assigned} Assigned</span>
          <span className="inline-flex items-center rounded-full bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-700">{statObj.unassigned} Unassigned</span>
        </div>
        <div className="flex items-center gap-2 ml-auto">
          <button
            type="button"
            onClick={() => setShowFilter(true)}
            aria-label="Filters"
            className="order-last flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors hover:border-sky-400 hover:text-sky-500 md:hidden"
          >
            <img src={filterSvg} alt="" className="h-4 w-4 opacity-70" />
          </button>
          {localStorage.getItem("mc_role") != 2 && (
            <SlButton
              variant="primary"
              size="small"
              onClick={() => {
                setAdd(true);
                setFlag("add");
              }}
            >
              <SlIcon library="lucide" name="plus" slot="prefix"></SlIcon>
              Add Brand
            </SlButton>
          )}
          <CSVLink
            data={downloadData.map((brand) => {
              let obj = {
                brand_name: brand.brand_name,
                alias_names: brand.alias_names,
                assigned_to: brand.sales_details[0]?.assigned_to,
                brand_ad_type: brand.brand_ad_type,
                brand_location: brand.brand_location,
                brand_type: BrandsTypes.find((row) => row.value === brand.brand_type)?.label || '-',
              };
              return obj;
            })}
            headers={csvHeaders}
            filename={"brands.csv"}
            ref={csvLinkRef}
          ></CSVLink>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <sl-tooltip content="Download brands">
              <button
                type="button"
                onClick={() => downloadBrands()}
                className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors hover:border-sky-400 hover:text-sky-500"
              >
                <SlIcon library="lucide" name="download"></SlIcon>
              </button>
            </sl-tooltip>
          )}
        </div>
      </div>

      {/* ===== Filters (desktop inline; mobile uses the drawer below).
             mobHide (not Tailwind `hidden`) because a global
             `.hidden{display:none!important}` would beat `md:flex`. ===== */}
      <div className="mt-4 flex flex-wrap items-end gap-3 rounded-xl border border-slate-200 bg-white p-3 shrink-0 mobHide">
        {renderFilters(false)}
      </div>
      <p className="mt-4 mb-3 text-sm text-slate-500 shrink-0">
        Showing <span className="font-semibold text-slate-700">{brandData?.length || 0}</span> of {statObj.total} brands
      </p>
      <div className="min-h-0 flex-1 overflow-y-auto pr-1">
      {brandData?.length && !loader ? (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {brandData.map((item, index) => {
            const isSelected = mergeIds.map((obj) => obj.id).includes(item.brand_id);
            const isB2b = localStorage.getItem("role") === roles.b2b;
            const typeLabel = BrandsTypes.find((row) => row.value === item.brand_type)?.label || "-";
            return (
              <div
                key={item.brand_id}
                className={`relative rounded-xl border bg-white p-3 transition-shadow hover:shadow-md ${isSelected ? "border-[#4952FA] bg-[#f5f7ff] ring-1 ring-[#4952FA]" : "border-slate-200"}`}
              >
                <div className="flex items-start gap-2">
                  {isB2b && (
                    <input
                      type="checkbox"
                      className="mt-1 h-4 w-4 shrink-0 cursor-pointer accent-[#4952FA]"
                      checked={isSelected}
                      onChange={() => handleCheckboxChange({ id: item.brand_id, label: item.brand_name })}
                    />
                  )}
                  <img
                    src={item?.logo_url || getGenerateUrl(item.brand_name)}
                    alt="logo"
                    className="h-9 w-9 shrink-0 rounded-lg border border-slate-100 bg-slate-50 object-contain p-0.5"
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-start justify-between gap-2">
                      <div className="truncate font-semibold capitalize text-slate-800" title={item.brand_name}>{item.brand_name}</div>
                      <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${item.status === 1 ? "bg-green-50 text-green-700" : "bg-slate-100 text-slate-500"}`}>
                        {item.status === 1 ? "Active" : "Inactive"}
                      </span>
                    </div>
                    <div className="mt-0.5 text-xs text-slate-400">#{item.brand_id} · {typeLabel} · {item.brand_location || "—"}</div>
                  </div>
                </div>

                <div className="mt-3 grid grid-cols-2 gap-x-3 gap-y-2">
                  <div className="min-w-0">
                    <div className="text-[11px] uppercase tracking-wide text-slate-400">Assigned To</div>
                    <div className="truncate text-sm font-medium text-slate-700">{item.sales_details?.[0]?.assigned_to || "Unassigned"}</div>
                  </div>
                  <div className="min-w-0">
                    <div className="text-[11px] uppercase tracking-wide text-slate-400">Created</div>
                    <div className="text-sm font-medium text-slate-700">{formatDate(item.date)}</div>
                  </div>
                  <div className="col-span-2 min-w-0">
                    <div className="text-[11px] uppercase tracking-wide text-slate-400">Alias Names</div>
                    <div className="truncate text-sm font-medium text-slate-700">{item.alias_names || "—"}</div>
                  </div>
                </div>

                {localStorage.getItem("mc_role") != 2 && (
                  <div className="mt-2.5 flex items-center justify-end gap-1 border-t border-slate-100 pt-2">
                    <sl-tooltip content="Edit Brand">
                      <sl-icon-button
                        library="lucide"
                        name="edit"
                        onClick={() => {
                          setEditdata(item);
                          setActionId({ id: item.brand_id, name: item.brand_name });
                          checkRequestPending(item);
                        }}
                      ></sl-icon-button>
                    </sl-tooltip>
                    {item.sales_details?.[0]?.assigned_to ? (
                      <sl-tooltip content="Unassign Brand">
                        <sl-icon-button
                          library="lucide"
                          name="user-minus"
                          style={{ color: "#d92d20" }}
                          onClick={() => setUnassignTarget(item)}
                        ></sl-icon-button>
                      </sl-tooltip>
                    ) : (
                      <sl-tooltip content="Assign Brand">
                        <sl-icon-button
                          library="lucide"
                          name="user-plus"
                          onClick={() => {
                            setAssign(true);
                            setActionId({ id: item.brand_id, name: item.brand_name });
                          }}
                        ></sl-icon-button>
                      </sl-tooltip>
                    )}
                    <sl-tooltip content="Assign Target">
                      <sl-icon-button
                        library="lucide"
                        name="indian-rupee"
                        onClick={() => {
                          setTarget(true);
                          setActionId({ id: item.brand_id, name: item.brand_name });
                          set_Sales_Person_Id(item.sales_person_id);
                        }}
                      ></sl-icon-button>
                    </sl-tooltip>
                    <sl-tooltip content="View POC">
                      <sl-icon-button
                        library="lucide"
                        name="eye"
                        onClick={() => fetchPOC(item.brand_id)}
                      ></sl-icon-button>
                    </sl-tooltip>
                    <sl-tooltip content="Assign History">
                      <sl-icon-button
                        library="lucide"
                        name="history"
                        onClick={() => setHistoryBrand({ id: item.brand_id, name: item.brand_name })}
                      ></sl-icon-button>
                    </sl-tooltip>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : !brandData?.length && !loader ? (
        <div className="rounded-2xl border border-slate-200 bg-white py-16 text-center text-slate-400">No brands found</div>
      ) : (
        <div className="flex justify-center py-16">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      </div>
      <div className="mt-3 flex shrink-0 justify-end">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
      </div>

      {/* ===== Floating selection / merge bar ===== */}
      {mergeIds.length >= 1 && (
        <div className="fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 items-center gap-4 rounded-full bg-slate-900 py-2 pl-5 pr-3 text-white shadow-xl">
          <span className="text-sm font-medium">{mergeIds.length} selected</span>
          <button
            type="button"
            onClick={() => setMerge(true)}
            className="inline-flex items-center gap-1.5 rounded-full bg-[#4952FA] px-4 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-[#3a43e0]"
          >
            <SlIcon library="lucide" name="git-merge"></SlIcon>
            Merge
          </button>
          <button
            type="button"
            onClick={() => setMergeIds([])}
            title="Clear selection"
            className="flex h-7 w-7 items-center justify-center rounded-full transition-colors hover:bg-white/10"
          >
            <SlIcon library="lucide" name="x"></SlIcon>
          </button>
        </div>
      )}
      {add && <AddBrand show={add} setShow={setAdd} flag={flag} actionId={actionId} setActionId={setActionId} loadData={getBrands} editData={editData} setEditData={setEditdata} categories={categories} currentPage={currentPage} setCurrentPage={setCurrentPage}/>}
      {merge && (
        <Merge
          show={merge}
          setShow={setMerge}
          ids={mergeIds}
          setIds={setMergeIds}
          loadData={getBrands}
        />
      )}
      {viewPoc && <POCC show={viewPoc} setShow={setviewPoc} contacts={POC} />}
      {assign && (
        <AssignBrand
          show={assign}
          setShow={setAssign}
          loadData={getBrands}
          actionId={actionId}
          setActionId={setActionId}
          currentPage={currentPage}
        />
      )}
      {target && <AssignTarget show={target} setShow={setTarget} actionId={actionId}  sales_person_id={sales_person_id}/>}
      {historyBrand && (
        <AssignHistory
          show={historyBrand ? true : false}
          setShow={() => setHistoryBrand(null)}
          brand={historyBrand}
        />
      )}
      {unassignTarget && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 p-4"
          onClick={() => { if (!unassignClicked) setUnassignTarget(null); }}
        >
          <div
            className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600">
                <sl-icon library="lucide" name="user-minus"></sl-icon>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-slate-800">Unassign brand?</h3>
                <p className="mt-1 text-sm text-slate-500">
                  This removes{" "}
                  <span className="font-medium text-slate-700">{unassignTarget.brand_name}</span>
                  {unassignTarget.sales_details?.[0]?.assigned_to ? (
                    <>
                      {" "}from{" "}
                      <span className="font-medium text-slate-700">
                        {unassignTarget.sales_details[0].assigned_to}
                      </span>
                    </>
                  ) : null}
                  .
                </p>
              </div>
            </div>
            <div className="mt-5 flex justify-end gap-2">
              <button
                type="button"
                className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 disabled:opacity-60"
                onClick={() => setUnassignTarget(null)}
                disabled={unassignClicked}
              >
                Cancel
              </button>
              <button
                type="button"
                className="inline-flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-60"
                onClick={confirmUnassign}
                disabled={unassignClicked}
              >
                {unassignClicked && (
                  <span className="spinner-border spinner-border-sm" role="status"></span>
                )}
                {unassignClicked ? "Unassigning..." : "Unassign"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showFilter && (
        <SlDrawer
          open={showFilter}
          onSlRequestClose={() => setShowFilter(false)}
          placement="bottom"
          noHeader
          onSlAfterHide={() => setShowFilter(false)}
          style={{ "--size": "fit-content" }}
        >
          <div className="relative">
            <h3 className="mb-3 text-lg font-semibold text-slate-800">Filters</h3>
            <hr className="mb-4" />
            <div className="flex flex-col gap-4">
              {renderFilters(true)}
            </div>
            <SlIcon
              className="absolute -top-1 right-0 cursor-pointer text-2xl text-slate-400 hover:text-red-600"
              name="x-circle"
              onClick={() => setShowFilter(false)}
            ></SlIcon>
          </div>
        </SlDrawer>
      )}
      {showDrawer && (
        <SlDrawer
          open={showDrawer}
          label="Pending Approval Request"
          onSlRequestClose={() => setShowDrawer(false)}
          onSlAfterHide={() => setShowDrawer(false)}
          style={{ zIndex: 1000, "--size": "850px" }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f5f7fa",
              fontFamily: "'Inter', 'Segoe UI', 'Arial', sans-serif",
            }}
          >
            {/* ===== Alert Banner ===== */}
            <div
              style={{
                background: "linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%)",
                padding: "16px 24px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                borderBottom: "3px solid #f39c12",
                boxShadow: "0 2px 8px rgba(243, 156, 18, 0.15)",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f39c12"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    margin: 0,
                    color: "#2d3436",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "1.4",
                    letterSpacing: "-0.01em",
                  }}
                >
                  {pendingRequestData?.user_name || "User"}'s Request Pending
                </p>
                <p
                  style={{
                    margin: "4px 0 0 0",
                    color: "#636e72",
                    fontSize: "14px",
                    lineHeight: "1.4",
                    fontWeight: "500",
                  }}
                >
                  This record is locked for editing until the pending request is reviewed
                </p>
              </div>
            </div>

            {/* ===== Main Content ===== */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "24px",
              }}
            >
              {(() => {
                const payload = pendingRequestData?.updated_payload || {};
                const hasLogo = Boolean(payload?.logo_url);

                return (
                  <div
                    style={{
                      display: "flex",
                      gap: "24px",
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "24px",
                      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                      border: "1px solid #e1e8ed",
                    }}
                  >
                    {/* ===== Left Section: Details ===== */}
                    <div style={{ flex: 1 }}>
                      <h3
                        style={{
                          margin: "0 0 20px 0",
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#2d3436",
                          borderBottom: "2px solid #0984e3",
                          paddingBottom: "10px",
                        }}
                      >
                        Updated Details
                      </h3>
                      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                        {/* Formatting comes from the shared brand hooks (payload/brandFormat)
                            so BrandChecker, the legacy renderer and this panel cannot drift
                            apart. Layout/data source intentionally unchanged: this panel
                            shows the submitted "Updated Details" for a PENDING request. */}
                        {Object.entries(payload).map(([key, value]) => {
                          if (BRAND_HIDDEN_FIELDS.includes(key)) return null;

                          const displayKey = brandFieldLabel(key);

                          const isEmptyValue =
                            value === null ||
                            value === undefined ||
                            value === "" ||
                            (Array.isArray(value) && value.length === 0);

                          const formatted = formatBrandValue(key, value);
                          const displayValue = isEmptyValue
                            ? "-"
                            : formatted !== undefined
                            ? formatted
                            : String(value);

                          return (
                            <div
                              key={key}
                              style={{
                                display: "flex",
                                padding: "12px 16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                border: "1px solid #e9ecef",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#e9ecef";
                                e.currentTarget.style.borderColor = "#dee2e6";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                e.currentTarget.style.borderColor = "#e9ecef";
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  color: "#636e72",
                                  minWidth: "180px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {displayKey.replace(/_/g, " ")}:
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: "#2d3436",
                                  fontWeight: "500",
                                  wordBreak: "break-word",
                                }}
                              >
                                {displayValue}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* ===== Right Section: Logo ===== */}
                    <div
                      style={{
                        width: "220px",
                        flexShrink: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      <h3
                        style={{
                          margin: 0,
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#2d3436",
                          borderBottom: "2px solid #0984e3",
                          paddingBottom: "10px",
                        }}
                      >
                        Brand Logo
                      </h3>
                      {hasLogo ? (
                        <>
                          <div
                            style={{
                              width: "100%",
                              height: "220px",
                              border: "2px solid #e1e8ed",
                              borderRadius: "12px",
                              padding: "16px",
                              backgroundColor: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                            }}
                          >
                            <img
                              src={payload.logo_url}
                              alt={
                                payload?.brand_name
                                  ? `${payload.brand_name} logo`
                                  : "Brand logo"
                              }
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                              }}
                              referrerPolicy="no-referrer"
                            />
                          </div>
                          <a
                            href={payload.logo_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              fontSize: "12px",
                              color: "#0984e3",
                              textAlign: "center",
                              wordBreak: "break-all",
                              textDecoration: "none",
                              padding: "8px",
                              backgroundColor: "#e3f2fd",
                              borderRadius: "6px",
                              fontWeight: "500",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#bbdefb";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "#e3f2fd";
                            }}
                          >
                            View Full Size →
                          </a>
                        </>
                      ) : (
                        <div
                          style={{
                            width: "100%",
                            height: "220px",
                            border: "2px dashed #cbd5e0",
                            borderRadius: "12px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#a0aec0",
                            fontSize: "14px",
                            fontWeight: "500",
                            gap: "8px",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <circle cx="8.5" cy="8.5" r="1.5"></circle>
                            <polyline points="21 15 16 10 5 21"></polyline>
                          </svg>
                          <span>No logo available</span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>

            {/* ===== Footer ===== */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 24px",
                backgroundColor: "#fff",
                borderTop: "2px solid #e1e8ed",
                boxShadow: "0 -2px 12px rgba(0, 0, 0, 0.04)",
              }}
            >
              <div style={{ fontSize: "13px", color: "#636e72", fontWeight: "500" }}>
                Submitted by: <strong>{pendingRequestData?.user_name || "Unknown"}</strong>
              </div>
              <button
                style={{
                  backgroundColor: "#d63031",
                  color: "#fff",
                  border: "none",
                  padding: "12px 28px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxShadow: "0 2px 8px rgba(214, 48, 49, 0.3)",
                }}
                onClick={handleSkipEditing}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#c0392b";
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(214, 48, 49, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#d63031";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(214, 48, 49, 0.3)";
                }}
              >
                Close & Skip Editing
              </button>
            </div>
          </div>
        </SlDrawer>
      )}
    </>
  );
}

export default Brands;
